// 初始化项目的时候填入的变量, 请谨慎修改, 会影响各个地方的使用
export var componentName = 'ComponentMobileSample';
export var libraryName = 'component-mobile-sample';
// js计算尺寸需要
export var size_1_px_rem = '0.01rem';
